import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'

type StatusPanelSectionProps = {
  label: string
  children: React.ReactNode
}

export const StatusPanelSection: React.FC<StatusPanelSectionProps> = ({
  label,
  children,
}) => {
  return (
    <div
      data-test-id="section"
      css={css`
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
      `}
    >
      <StatusPanelSectionLabel label={label} />
      {children}
    </div>
  )
}

type StatusPanelSectionLabelProps = {
  label: string
}
const StatusPanelSectionLabel: React.FC<StatusPanelSectionLabelProps> = ({
  label,
}) => {
  return (
    <div
      data-test-id="label"
      css={css`
        font-weight: ${font.weight.bold};
        font-size: 12px;
        line-height: 125%;
        letter-spacing: 0.02em;
        color: ${colors.textStrong};
        margin-right: 12px;
        min-width: 98px;
        max-width: 98px;
        margin-top: 10px;
      `}
      className="section-title"
    >
      {label}
    </div>
  )
}
